/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  permissionsRequest: ['page', 'page_size', 'filter'],
  permissionsSuccess: ['list'],

  permissionRequest: ['id'],
  permissionSuccess: ['focusRow'],
  permissionReset: null,

  savePermissionsRequest: ['data'],
  savePermissionsSuccess: ['savePermissionsResult'],
  savePermissionsReset: null,

  deletePermissionsRequest: ['id'],
  deletePermissionsSuccess: ['deletePermissionsResult', 'id'],
  deletePermissionsReset: null,

  permissionsPagesRequest: null,
  permissionsPagesSuccess: ['pages'],

  permissionsReset: null,

  permissionsChangeFilter: ['filter'],

  permissionsFetchingReset: null,
})

export const PermissionsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  pages: [],
  pagesFetching: false,

  page: 1,
  page_size: 3,
  filter: [],

  savePermissionsResult: null,
  savePermissionsFetching: false,

  deletePermissionsResult: null,
  deletePermissionsFetching: false,

  focusRow: null,
})

/* ------------- Selectors ------------- */
export const PermissionsSelectors = {
  getState: state => state.permissions,
}

export const permissionsRequest = (state, {page, page_size, filter}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)
  //filter && (newState.filter = filter)

  return state.merge(newState)
}
export const permissionsSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}
export const permissionsReset = () => {
  return INITIAL_STATE
}

export const permissionRequest = (state, {}) => {
  return state.merge({fetching: true})
}
export const permissionSuccess = (state, {focusRow}) => {
  return state.merge({fetching: false, focusRow})
}
export const permissionReset = state => {
  return state.merge({focusRow: null})
}

export const savePermissionsRequest = (state, {data}) => {
  return state.merge({savePermissionsFetching: true})
}
export const savePermissionsSuccess = (state, {savePermissionsResult}) => {
  return state.merge({
    savePermissionsFetching: false,
    savePermissionsResult,
  })
}
export const savePermissionsReset = state => {
  return state.merge({savePermissionsResult: null})
}

export const deletePermissionsRequest = (state, {id}) => {
  return state.merge({deletePermissionsFetching: true})
}
export const deletePermissionsSuccess = (state, {deletePermissionsResult, id}) => {
  return state.merge({
    deletePermissionsFetching: false,
    deletePermissionsResult,
  })
}
export const deletePermissionsReset = state => {
  return state.merge({deletePermissionsResult: null})
}

export const permissionsPagesRequest = (state, {}) => {
  return state.merge({pagesFetching: true})
}
export const permissionsPagesSuccess = (state, {pages}) => {
  return state.merge({pagesFetching: false, pages})
}

export const permissionsFetchingReset = state => {
  return state.merge({
    fetching: false,
    savePermissionsFetching: false,
    deletePermissionsFetching: false,
    pagesFetching: false,
  })
}

export const permissionsChangeFilter = (state, {filter}) => {
  return state.merge({filter})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.PERMISSIONS_REQUEST]: permissionsRequest,
  [Types.PERMISSIONS_SUCCESS]: permissionsSuccess,
  [Types.PERMISSIONS_RESET]: permissionsReset,

  [Types.PERMISSION_REQUEST]: permissionRequest,
  [Types.PERMISSION_SUCCESS]: permissionSuccess,
  [Types.PERMISSION_RESET]: permissionReset,

  [Types.SAVE_PERMISSIONS_REQUEST]: savePermissionsRequest,
  [Types.SAVE_PERMISSIONS_SUCCESS]: savePermissionsSuccess,
  [Types.SAVE_PERMISSIONS_RESET]: savePermissionsReset,

  [Types.DELETE_PERMISSIONS_REQUEST]: deletePermissionsRequest,
  [Types.DELETE_PERMISSIONS_SUCCESS]: deletePermissionsSuccess,
  [Types.DELETE_PERMISSIONS_RESET]: deletePermissionsReset,

  [Types.PERMISSIONS_PAGES_REQUEST]: permissionsPagesRequest,
  [Types.PERMISSIONS_PAGES_SUCCESS]: permissionsPagesSuccess,

  [Types.PERMISSIONS_CHANGE_FILTER]: permissionsChangeFilter,

  [Types.PERMISSIONS_FETCHING_RESET]: permissionsFetchingReset,
})
